const google = window.google

const map = document.getElementById('google-map')

const state = {
  map: null,
  bounds: null,
  mapCenter: null,
}

const fn = {
  init: () => {
    state.mapCenter = new google.maps.LatLng(43.7488639, -74.8175827)

    fn.setupMap()
  },

  setupMap: () => {
    const opts = {
      center: state.mapCenter,
      zoom: 11,
      maxZoom: 11,
      minZoom: 11,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
      scrollwheel: false,
      styles: [
        {
          featureType: 'administrative',
          elementType: 'geometry',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'poi',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'road',
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'on',
            },
          ],
        },
        {
          featureType: 'transit',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
      ],
    }

    state.map = new google.maps.Map(map, opts)
    state.bounds = new google.maps.LatLngBounds()
  },
}

export default {
  can: () => map,
  run: fn.init,
}
